import { defineNuxtRouteMiddleware, navigateTo, useNuxtApp } from 'nuxt/app';
import type { RouteLocationRaw } from 'vue-router';
import { SEPARATE_BY_DASH, staticRedirectPages } from '~~/shop/app/config/RedirectConfig';

export default defineNuxtRouteMiddleware((to) => {
  const { $localePath } = useNuxtApp();
  const { fullPath } = to;

  // Handle staticRedirectPages
  const splitByQuestionMarkPath = fullPath.split('?');
  const questionMarkLessPath = splitByQuestionMarkPath[0] ?? '';
  const splitByAnchorPath = questionMarkLessPath.split('#');
  const path = splitByAnchorPath[0] ?? '';

  const matchedPage = Object.values(staticRedirectPages).find(pageConfig => pageConfig.regex.test(path));
  if (matchedPage) {
    let localePathParam: RouteLocationRaw;
    if ('replacement' in matchedPage) {
      if (matchedPage.replacement === SEPARATE_BY_DASH) {
        localePathParam = path.match(matchedPage.regex)?.slice(1)?.join('-') ?? '';
      } else {
        localePathParam = path.replace(matchedPage.regex, matchedPage.replacement);
      }
    } else if (matchedPage.name) {
      const params = 'params' in matchedPage ? matchedPage.params : null;
      localePathParam = {
        name: matchedPage.name,
        params: Object.fromEntries(Object.entries(params || {}).map(([key, value]) => ([key, path.replace(matchedPage.regex, value)]))),
      };
      if ('queryParams' in matchedPage) {
        const queryParams = Object.entries(matchedPage.queryParams)?.reduce((acc, [key, value]) => {
          const replacedValue = path.replace(matchedPage.regex, value);
          acc += acc.length ? `&${key}=${replacedValue}` : `${key}=${replacedValue}`;
          return acc;
        }, '');
        if (splitByQuestionMarkPath.length === 1) {
          splitByQuestionMarkPath.push(queryParams);
        } else if (splitByQuestionMarkPath.length > 1) {
          splitByQuestionMarkPath[1] = `${splitByQuestionMarkPath[1]}&${queryParams}`;
        }
      }
    } else {
      return;
    }
    const redirectPath = `${$localePath(localePathParam)}${splitByAnchorPath.length > 1 ? '#' + splitByAnchorPath[1] : ''}${splitByQuestionMarkPath.length > 1 ? '?' + splitByQuestionMarkPath[1] : ''}`;
    return navigateTo(redirectPath, { redirectCode: 301 });
  }
});
